import { Box, Typography, Button } from "@mui/material";
import { useTheme } from "@emotion/react";
import type { Theme } from "@mui/material/styles";
import Image from "@/components/image";
import CongratsIcon from "@/assets/illustrations/cc_task.gif";
import { useActivePhase } from "../useActivePhase";
import { animationFor } from "../sectionAnimation";

type CareerClimbSectionProps = {
  careerClimb: { name: string };
  isActive: boolean;
  onAdvance: () => void;
  isLast: boolean;
};

export const CareerClimbSection = ({
  careerClimb,
  isActive,
  onAdvance,
  isLast,
}: CareerClimbSectionProps) => {
  const theme = useTheme() as Theme;
  const phase = useActivePhase(isActive);
  return (
    <Box
      sx={{
        textAlign: "center",
        backgroundColor: "#fff",
        borderRadius: 2,
        padding: "50px",
        maxWidth: 600,
        width: "95%",
        animation: animationFor(phase),
      }}
    >
      <Typography color="secondary.main" variant="h3" fontFamily="Nunito">
        Career Climb Complete!
      </Typography>
      <Box>
        <Image
          alt="scrolling check list all completed"
          src={CongratsIcon}
          sx={{ width: "128px", height: "128px" }}
        />
      </Box>
      <Typography
        variant="h6"
        fontFamily="ProximaNova Bold"
        sx={{ textAlign: "center", color: "text.primary" }}
      >
        You completed{" "}
        <span style={{ color: theme.palette.secondary.main }}>
          {careerClimb.name}
        </span>
      </Typography>
      <Typography
        variant="h6"
        fontFamily="ProximaNova Bold"
        sx={{ textAlign: "center", color: "text.primary" }}
      >
        Look at you go...
      </Typography>
      <Button
        color="secondary"
        variant="contained"
        sx={{ width: "100%", height: "48px", marginTop: "80px" }}
        onClick={onAdvance}
      >
        {isLast ? "Keep Climbing" : "Next"}
      </Button>
    </Box>
  );
};
